import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import formatTimeRange from '../../utils/formatTimeRange';
import Schedule from '../Schedule';
import useLanguage from '../../hooks/useLanguage';

const DealerSchedule = ({ departments, currentDepartmentType }) => {
  const { t } = useTranslation();
  const lang = useLanguage();
  const today = new Date();
  const currentDayOfWeek = today.getDay();

  const departmentDataMap = departments
    .find(department => department.type === currentDepartmentType)
    ?.hours?.map(hour => {
      const { dayOfWeek, start, end, dayOfWeekName } = hour || {};
      if (typeof dayOfWeek !== 'number' || Number.isNaN(dayOfWeek)) return null;

      const time = formatTimeRange(start, end, lang, t);
      const isCurrentDayOfWeek = currentDayOfWeek === dayOfWeek;
      return {
        title: t(dayOfWeekName),
        time,
        isCurrentDayOfWeek,
      };
    });

  return <Schedule items={departmentDataMap} dataTestId="cy-dealer-schedule" isDealerDetailSchedule />;
};

DealerSchedule.propTypes = {
  currentDepartmentType: PropTypes.string.isRequired,
  departments: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.string,
      end: PropTypes.string,
      dayOfWeek: PropTypes.number,
      dayOfWeekName: PropTypes.string,
    }),
  ),
};

DealerSchedule.defaultProps = {
  departments: [],
};

export default DealerSchedule;
